// extracted by mini-css-extract-plugin
export default {"education":"Education_education__cunb6","educationAvatar":"Education_educationAvatar__lOnFl","educationInfo":"Education_educationInfo__2CqRK"};